// import { isArray } from "lodash-es";
import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";
import personIcon from "../../assets/images/icon/person-icon.svg";
import Icon from "../Icon";
import { searchEmployee } from "../../utils/employee";
import { isEmpty } from "lodash";

const SearchEmployeesDisplayPanel = ({ employees }) => {
  let displayPanel = <>사람 선택</>;
  if (!isEmpty(employees)) {
    displayPanel = (
      <>
        <span className='inline-block'>{employees[0].name}</span>
        {employees.length > 1 && <span className="inline-block"> 외 {employees.length - 1}명</span>}
      </>
    );
  }
  return displayPanel;
};

const SearchEmployees = (props) => {
  const {
    onChange,
    field,
    defaultValue,
    className,
    isSingle,
    options,
  } = props;

  const [_employees, _setEmployees] = useState([]);

  useEffect(() => {
    _setEmployees(defaultValue);
  }, [defaultValue]);

  const _searchEmployees = () => {
    searchEmployee((employees) => {
      _setEmployees(employees);
      onChange({
        target: {
          name: field.key,
          value: employees
        }
      });
    }, _employees, { isSingle, ...options });
  };

  return (
    <div
      className={classnames("component-select-employee", className)}
      onClick={_searchEmployees}
    >
      <Icon src={personIcon} className="margin-right-8" />
      <span className="inline-block vertical-middle">
        <SearchEmployeesDisplayPanel employees={_employees} />
      </span>
    </div>
  );
};
export default SearchEmployees;
